import parse from 'utils/parse';

import { isSummerContestBannerActive } from '../summer-contest-banner/summer-contest-banner.settings';

import messages from './video-dreams-banner.i18n';

const makeTestId = (...ids: string[]): string => parse.toTestId('landing', 'video-dreams-banner', ...ids);

const testId = Object.freeze({
  component: makeTestId(),
  video: makeTestId('video'),
  signUp: makeTestId('sign-up'),
});

const config = {
  rotation: [
    messages.pages.landing.videoDreamsBanner.livejasmin.rotation.yourTime,
    messages.pages.landing.videoDreamsBanner.livejasmin.rotation.yourMoney,
    messages.pages.landing.videoDreamsBanner.livejasmin.rotation.yourRules,
  ],
  rotationDelayInMs: 2000,
  video: {
    dev: {
      desktop: 'https://gallerydev.dditscdn.com/public/13/5819a329c4b24e47cea686d5093729ae.mp4',
      mobile: 'https://gallerydev.dditscdn.com/public/1b/66bfa479790f2972c56acc8d3e52a9d4.mp4',
    },
    prod: {
      desktop: 'https://gallery.dditscdn.com/public/1e/dba34e0116e375730f3220b2ee3c4e21.mp4',
      mobile: 'https://gallery.dditscdn.com/public/16/3027f6e137ebbff360708543a3fd456a.mp4',
    },
  },
  // TODO: Clean up after summer contest ends. MSC-32871
  scrollPauseBufferInPx: isSummerContestBannerActive() ? 700 : 200,
};

export { testId, config };
